import { render, staticRenderFns } from "./RefundRequest.vue?vue&type=template&id=52753474"
import script from "./RefundRequest.vue?vue&type=script&lang=js"
export * from "./RefundRequest.vue?vue&type=script&lang=js"
import style0 from "./RefundRequest.vue?vue&type=style&index=0&id=52753474&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports